exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.font-xlarge[data-v-1fea05d5]{font-size:x-large\n}\n.font-large[data-v-1fea05d5]{font-size:large\n}\n", ""]);

// exports
